export default {
	state: {
		activities: [
			"Arts and crafts",
			"Art therapy",
			"Cooking classes",
			"Exercise classes",
			"Group games",
			"Music therapy",
			"Outings and excursions",
			"Pet therapy",
			"Social activities"
		],
		amenities: [
			"Alcohol not permitted",
			"Alcohol served",
			"Aromatherapy",
			"BBQ area",
			"Beauty services",
			"Café",
			"Church services",
			"Cinema",
			"Computer and internet access",
			"Courtyard",
			"Day spa",
			"Dining room",
			"Emergency call service",
			"Fireplace",
			"Foxtel",
			"Gardens",
			"Hairdressing",
			"In-home chef",
			"Kitchen on-site",
			"Laundry on-site",
			"Library",
			"Lift",
			"Menu choices",
			"Newspaper",
			"Outdoor dining",
			"Pet(s) live on site",
			"Pets can move in",
			"Pets can visit",
			"Pharmacy services",
			"Phone in-room",
			"Resident buddy program",
			"Shop",
			"Smoking area",
			"TV",
			"Vegetable garden",
			"Visitor parking",
			"Wi-Fi"
		],
		archiveReasons: [
			"Permanent care",
			"Respite care",
			"Transition Care Program",
			"Discharged home",
			"Re-admitted",
			"Deceased"
			// "Other"
		],
		searchReasons: ["Shortlisting options for patient care", "Admin or other"],
		paperworkStatus: ["Complete", "Pending"],
		searchTypes: ["Hospital in-patient", "Out-patient"],
		careneeds: {
			respite: [
				{
					value: "dementiafriendly",
					label: "Dementia support"
				},
				{
					value: "dementiahighcare",
					label: "Dementia high care (integrated)"
				},
				{
					value: "nonweightbearing",
					label: "Non-weight bearing"
				},
				{
					value: "dementiasecure",
					label: "Secure dementia care"
				}
			],
			permanent: [
				{
					value: "generalcare",
					label: "General care"
				},
				{
					value: "dementiafriendly",
					label: "Dementia support"
				},
				{
					value: "dementiahighcare",
					label: "Dementia high care (integrated)"
				},
				{
					value: "dementiasecure",
					label: "Secure dementia care"
				},
				{
					value: "bariatric",
					label: "Bariatric care"
				}
				// {
				// 	value: "palliative",
				// 	label: "Palliative care",
				// },
			]
		},
		caretypes: {
			advanced: [
				"Auslan (sign language)",
				"Challenging behaviours",
				"General mental health",
				"Jejunostomy feeding",
				"Motor neurone disease",
				"Multiple sclerosis (MS)",
				"Nasogastric feeding",
				"Peg feeds",
				"Peri dialysis",
				"Physiotherapy (on-site)",
				"Power wheelchair",
				"Spinal care",
				"Tracheotomy"
			],
			agestage: ["Permanent care", "Ageing in place", "Low care", "High care"],
			categories: ["Permanent care", "Respite care"],
			mentalhealth: [
				{
					value: "geriatricpsychiatryunit",
					label: "Geriatric psychiatry unit"
				},
				{ value: "palliative", label: "Palliative care unit" }
			],
			specialised: [
				"Dementia support",
				"Dementia high care (integrated)",
				"Secure dementia care",
				"Bariatric care",
				// "Palliative care",
				"Post-operative care",
				"Transition care",
				"Facility is dementia specific (All residents have a form of dementia)"
			],
			shortstay: [
				"Day program",
				"Dedicated respite room(s)",
				"Emergency respite",
				"Non-ACAT respite accepted",
				"Non-weight bearing",
				"Planned respite",
				"Respite in secure dementia care"
			],
			therapyservices: [
				"Dental",
				"General practitioners",
				"Massage",
				"Nurse on call",
				"Optometry",
				"Physiotherapy",
				"Podiatry",
				"Psychiatry",
				"Psychology",
				"Reflexology",
				"Speech pathology"
			],
			provideSecureDementiaCare: [
				{
					type: "limited",
					label: "Limited to some rooms and shared spaces"
				},
				{
					type: "acrossall",
					label: "Across all rooms and shared spaces"
				}
			]
		},
		complexneeds: {
			respite: [],
			permanent: [
				{
					value: "auslan",
					label: "Auslan (sign language)"
				},
				{
					value: "challengingbehaviours",
					label: "Challenging behaviours"
				},
				{
					value: "generalmentalhealth",
					label: "General mental health"
				},
				{
					value: "jejunostomyfeeding",
					label: "Jejunostomy feeding"
				},
				{
					value: "motorneuronedisease",
					label: "Motor neurone disease"
				},
				{
					value: "multiplesclerosis",
					label: "Multiple sclerosis (MS)"
				},
				{
					value: "nasogastricfeeding",
					label: "Nasogastric feeding"
				},
				{
					value: "pegfeeds",
					label: "Peg feeds"
				},
				{
					value: "peridialysis",
					label: "Peri dialysis"
				},
				{
					value: "physiotherapy",
					label: "Physiotherapy (on-site)"
				},
				{
					value: "powerwheelchair",
					label: "Power wheelchair"
				},
				{
					value: "spinalcare",
					label: "Spinal care"
				},
				{
					value: "tracheotomy",
					label: "Tracheotomy"
				}
			]
		},
		dailyDataUserRoles: [
			{
				type: "dailydata-general",
				label: "DailyData user",
				description: null
			}
		],
		dailyCareUserRoles: [
			{
				type: "consumer",
				label: "Dailycare user",
				description: null
			}
		],
		financialCircumstances: {
			respite: ["Non-funded", "Funded"],
			permanent: ["Fully supported", "Partially supported", "RAD"]
		},
		gender: [
			{
				type: "Male",
				label: "Male"
			},
			{
				type: "Female",
				label: "Female"
			},
			{
				type: "Non-specific",
				label: "Non-specific"
			}
		],
		healthServiceTypes: [
			{
				type: "Private",
				label: "Private",
				description: ""
			},
			{
				type: "Public",
				label: "Public",
				description: ""
			}
		],
		hospitalTypes: [
			{
				type: "Private hospital",
				label: "Private hospital",
				description: ""
			},
			{
				type: "Public hospital",
				label: "Public hospital",
				description: ""
			}
		],
		notificationTypes: [
			{
				value: "joingroup",
				title: "Changes to your user profile",
				style: "info"
			},
			{
				value: "leavegroup",
				title: "Changes to your user profile",
				style: "info"
			},
			{
				value: "assignedsearch",
				title: "Care search assignment change",
				style: "info"
			}
		],
		searchActivitiesTypes: [
			{
				value: "activities",
				label: "All"
			},
			{
				value: "searchassigned",
				label: "Assignment change"
			},
			{
				value: "searchsaved",
				label: "Search was saved"
			},
			{
				value: "shortlistactive",
				label: "Added to shortlist"
			},
			{
				value: "shortlistdeleted",
				label: "Removed from shortlist"
			},
			{
				value: "shortlistpdf",
				label: "Shortlist PDF was exported"
			},
			{
				value: "shortlistlistingpdf",
				label: "Details included in shortlist PDF export"
			},
			{
				value: "shortlistprinted",
				label: "Shortlist printed"
			},
			{
				value: "shortlistemailed",
				label: "Shortlist was emailed"
			},
			{
				value: "shortlistlistingemailed",
				label: "Details shared by email"
			},
			{
				value: "searchupdated",
				label: "Search was updated"
			},
			{
				value: "listingnotified",
				label: "Facility notified of shortlisting"
			},
			{
				value: "searcharchived",
				label: "Search was archived"
			}
		],
		states: [
			{
				value: "NSW",
				label: "New South Wales"
			},
			{
				value: "VIC",
				label: "Victoria"
			},
			{
				value: "QLD",
				label: "Queensland"
			},
			{
				value: "WA",
				label: "Western Australia"
			},
			{
				value: "SA",
				label: "South Australia"
			},
			{
				value: "TAS",
				label: "Tasmania"
			},
			{
				value: "ACT",
				label: "Australian Capital Territory"
			},
			{
				value: "NT",
				label: "Northern Territory"
			}
		],
		listingCategories: [
			{
				type: "Residential aged care",
				label: "Government-funded Residential Aged Care",
				description: ""
			},
			{
				type: "SRS/SRF",
				label:
					"Supported Residential Services / Supported Residential Facility",
				description: ""
			}
		],
		listingUserRoles: [
			{
				type: "owner",
				label: "Owner",
				description:
					"Only one user can be the Owner, who is the primary contact for the account. The Owner can perform all of the same actions as Admins."
			},
			{
				type: "admin",
				label: "Admin",
				description:
					"Admins can perform all actions on the account. They can create, edit and delete listings and view reports on listing performance. Admins can also set and manage billing info, and invite other users."
			},
			{
				type: "manager",
				label: "Listing manager",
				description:
					"Managers can create, edit and delete listings and view reports on listing performance. They can't view billing information or invite users."
			},
			{
				type: "editor",
				label: "Listing editor",
				description:
					"Editors can only make changes to listings that they have been given access to. They can't view reports, billing information or invite users."
			},
			{
				type: "vacancy-editor",
				label: "Vacancy editor",
				description:
					"Vacancy editors can view and update vacancies for the selected listings."
			},
			{
				type: "report",
				label: "Report viewer",
				description:
					"Report viewers can see reports for the organisation and all listings."
			}
		],
		homecare: {
			specialisedservices: [
				"Assistive Technology",
				"Continence Advisory",
				"Dementia",
				"Hearing",
				"In-home respite care",
				"Mental Health",
				"Mobility",
				"People with terminal illness",
				"Vision",
				"Wellness and reablement"
			],
			specialneeds: [
				"Care leavers",
				"Focus on socially and financially disadvantaged people",
				"Parents separated from their children by forced adoption or removal",
				"People who are homeless or at risk of becoming homeless",
				"People who live in rural or remote areas",
				"Specific services for ATSI people",
				"Specific services for LGBTI people",
				"Specific services for people with CALD backgrounds",
				"Specific services for veterans"
			]
			// NOTE: Commenting these out until we can migrate the services properly
			// services: [
			// 	"Cleaning and domestic assistance",
			// 	"Equipment and technology",
			// 	"Food, cooking and meals",
			// 	"Home upkeep",
			// 	"Live-in care",
			// 	"Meal preparation",
			// 	"Medication support",
			// 	"Personal care, hygiene and grooming",
			// 	"Recreation and outings",
			// 	"Shopping and errands",
			// 	"Social support",
			// 	"Transport"
			// ],
			// specialisedcare: [
			// 	"24-hour care",
			// 	"After-hospital support",
			// 	"Allied health and therapy services",
			// 	"Continence support",
			// 	"Dementia support",
			// 	"End-of-life care"
			// ],
			// afterHospitalSupport: ["Rehabilitation", "Wound management"],
			// alliedHospitalSupport: [
			// 	"Counselling and support",
			// 	"Diet and nutrition",
			// 	"Diversional therapy",
			// 	"Exercise physiology",
			// 	"Hydrotherapy",
			// 	"Occupational therapy",
			// 	"Physiotherapy",
			// 	"Podiatry",
			// 	"Psychology",
			// 	"Restorative care",
			// 	"Speech pathology"
			// ],
			// careGiversRespite: [
			// 	"Community activities",
			// 	"Cottage house short stays",
			// 	"Day centre visits",
			// 	"Host family day visits",
			// 	"Host family short stays",
			// 	"In-home day visits"
			// ],
			// caseManagement: ["Provider-managed", "Option to self-manage"],
			// cleaningDomesticAssistance: [
			// 	"General cleaning",
			// 	"Linen services",
			// 	"Shopping and errands"
			// ],
			// equipmentAssistiveTechnology: [
			// 	"Car modifications",
			// 	"Communication aids",
			// 	"Home modifications",
			// 	"Medical care aids",
			// 	"Reading aids",
			// 	"Self-care aids",
			// 	"Support and mobility aids"
			// ],
			// homeUpkeep: ["Gardening", "Home maintenance and repairs"],
			// medicationSupport: ["Medication management", "Pharmacy collection"],
			// socialSupport: [
			// 	"Companionship visits",
			// 	"Recreation and outings",
			// 	"Phone/online contact"
			// ]
		},
		hospitalUserRoles: [
			{
				type: "connect-team-leader",
				label: "Team Leader",
				description:
					"Team leaders can search, save shortlists, send enquiries and view reports on their team's activity. They can't view billling information or invite users."
			},
			{
				type: "connect-case-manager",
				label: "Team Member",
				description:
					"Team members can search, save shortlists, send enquiries and view reports only on their activity. They can't view billing information or invite users"
			},
			{
				type: "care-coordinator",
				label: "Care Coordinator",
				description:
					"Care Coordinators can search, save shortlists, send enquiries and view reports on their team's activity. They can't view billing information or invite users"
			}
		],
		listingPlans: [
			{
				type: "Basic",
				label: "Basic",
				description: ""
			},
			{
				type: "Trial",
				label: "Trial",
				description: ""
			},
			{
				type: "Active non-subscriber",
				label: "Active non-subscriber",
				description: ""
			},
			{
				type: "Subscription level 1",
				label: "Subscription level 1",
				description: ""
			},
			{
				type: "Subscription level 2",
				label: "Subscription level 2",
				description: ""
			},
			{
				type: "Subscription level 3",
				label: "Subscription level 3",
				description: ""
			}
		],
		organisationTypes: [
			{
				type: "Private",
				label: "Private business",
				description: ""
			},
			{
				type: "Not-for-profit",
				label: "Not-for-profit organisation",
				description: ""
			},
			{
				type: "Government",
				label: "Government organisation",
				description: ""
			}
		],
		roomoptions: {
			advanced: [
				"Auslan (sign language)",
				"Challenging behaviours",
				"Lewy body dementia",
				"Motor neurone disease",
				"Multiple sclerosis (MS)",
				"Peg feeds",
				"Peri dialysis",
				"Power wheelchair",
				"Spinal care",
				"Tracheotomy"
			],
			bariatriccare: [
				{
					value: "2 staff",
					label: "2 staff"
				},
				{
					value: "3 staff",
					label: "3 staff"
				},
				{
					value: "Hoist",
					label: "Hoist"
				}
			],
			ensuites: [
				{
					type: "Private ensuite",
					label: "Private"
				},
				{
					type: "Shared ensuite",
					label: "Shared"
				},
				{
					type: "No ensuite",
					label: "No ensuite"
				}
			],
			maximumoccupancy: [
				{
					type: "1 person",
					label: "1 person"
				},
				{
					type: "2 person",
					label: "2 people"
				},
				{
					type: "3 person +",
					label: "3 or more people"
				}
			],
			occupancies: [
				{
					type: "Single",
					label: "Single"
				},
				{
					type: "Companion",
					label: "Companion"
				},
				{
					type: "Shared",
					label: "Shared"
				}
			],
			roomsize: [
				{
					type: "Size-is-static",
					label: "Size is always the same for this room type"
				},
				{
					type: "Size-varies-no-minimum",
					label: "Size varies for this room type between a min and max"
				}
			],
			srsFeeFrequencies: ["Weekly", "Monthly"]
		},
		specialisations: {
			cultures: [
				"Acehnese",
				"Acholi",
				"Afghan",
				"African American",
				"Afrikaner",
				"Akan",
				"Albanian",
				"Algerian",
				"American",
				"Amhara",
				"Anglo-Burmese",
				"Anglo-Indian",
				"Angolan",
				"Arab",
				"Argentinian",
				"Armenian",
				"Assyrian",
				"Australian Aboriginal",
				"Australian South Sea Islander",
				"Austrian",
				"Azeri",
				"Bahraini",
				"Balinese",
				"Bangladeshi",
				"Barbadian",
				"Bari",
				"Basque",
				"Batswana",
				"Belarusan",
				"Belgian",
				"Bengali",
				"Berber",
				"Bermudan",
				"Bhutanese",
				"Bolivian",
				"Bosnian",
				"Brazilian",
				"British",
				"Bruneian",
				"Bulgarian",
				"Burgher",
				"Burmese",
				"Burundian",
				"Cameroonian",
				"Canadian",
				"Caribbean Islander",
				"Catalan",
				"Central American",
				"Central and West African",
				"Central Asian",
				"Chaldean",
				"Channel Islander",
				"Chilean",
				"Chin",
				"Chinese",
				"Chinese Asian",
				"Colombian",
				"Congolese",
				"Cook Islander",
				"Coptic",
				"Costa Rican",
				"Croatian",
				"Cuban",
				"Cypriot",
				"Czech",
				"Danish",
				"Darfu/Darfurian",
				"Dinka",
				"Dutch",
				"Eastern European",
				"Ecuadorian",
				"Egyptian",
				"Emirati",
				"Eritrean",
				"Estonian",
				"Ethiopian",
				"Fijian",
				"Fijian Indian",
				"Filipino",
				"Finnish",
				"Flemish",
				"French",
				"French Canadian",
				"Frisian",
				"Fulani",
				"Georgian",
				"German",
				"Ghanaian",
				"Gibraltarian",
				"Gio",
				"Greek",
				"Guatemalan",
				"Gujarati",
				"Guyanese",
				"Hawaiian",
				"Hazara",
				"Hispanic (North American)",
				"Hmong",
				"Hungarian",
				"Hutu",
				"Icelandic",
				"Igbo",
				"I-Kiribati",
				"Indian",
				"Indian Tamil",
				"Indonesian",
				"Iranian",
				"Iraqi",
				"Irish",
				"Italian",
				"Ivorean",
				"Jamaican",
				"Japanese",
				"Javanese",
				"Jewish",
				"Jordanian",
				"Kadazan",
				"Karen",
				"Kashmiri",
				"Kazakh",
				"Kenyan",
				"Khmer (Cambodian)",
				"Korean",
				"Krahn",
				"Kunama",
				"Kurdish",
				"Kuwaiti",
				"Kyrgyz",
				"Lao",
				"Latvian",
				"Lebanese",
				"Liberian",
				"Libyan",
				"Lithuanian",
				"Luxembourg",
				"Macedonian",
				"Madi (Ma'di)",
				"Madurese",
				"Mainland South-East Asian",
				"Malawian",
				"Malay",
				"Malayali",
				"Maldivian",
				"Maltese",
				"Mandaean",
				"Mandinka",
				"Manx",
				"Maori",
				"Maritime South-East Asian",
				"Masai",
				"Mauritian",
				"Mayan",
				"Melanesian and Papuan",
				"Mexican",
				"Micronesian",
				"Moldovan",
				"Mon",
				"Mongolian",
				"Montenegrin",
				"Moroccan",
				"Mozambican",
				"Namibian",
				"Native North American Indian",
				"Nauruan",
				"Nepalese",
				"New Caledonian",
				"New Zealander",
				"Nicaraguan",
				"Nigerian",
				"Niuean",
				"Ni-Vanuatu",
				"North American",
				"Northern European",
				"Norwegian",
				"Nubian",
				"Nuer",
				"Ogaden",
				"Omani",
				"Oromo",
				"Otr Nth African & Mid. Eastern",
				"Pakistani",
				"Palestinian",
				"Papua New Guinean",
				"Paraguayan",
				"Parsi",
				"Pathan",
				"Peoples of the Sudan",
				"Peruvian",
				"Polish",
				"Polynesian",
				"Portuguese",
				"Puerto Rican",
				"Punjabi",
				"Qatari",
				"Rohingya",
				"Roma/Gypsy",
				"Romanian",
				"Russian",
				"Rwandan",
				"Salvadoran",
				"Samoan",
				"Saudi Arabian",
				"Scottish",
				"Senegales",
				"Serbian",
				"Seychellois",
				"Shona",
				"Sierra Leonean",
				"Sikh",
				"Sindhi",
				"Singaporean",
				"Sinhalese",
				"Slovak",
				"Slovene",
				"Solomon Islander",
				"Somali",
				"Sorb/Wend",
				"South African",
				"South American",
				"South Eastern European",
				"South Sudanese",
				"Southern and East African",
				"Southern Asian",
				"Southern European",
				"Spanish",
				"Sri Lankan",
				"Sri Lankan Tamil",
				"Sudanese",
				"Sundanese",
				"Swahili",
				"Swazilander",
				"Swedish",
				"Swiss",
				"Syrian",
				"Tahitian",
				"Taiwanese",
				"Tajik",
				"Tanzanian",
				"Tatar",
				"Telugu",
				"Temoq",
				"Thai",
				"Themne",
				"Tibetan",
				"Tigrayan",
				"Tigre",
				"Timorese",
				"Togolese",
				"Tokelauan",
				"Tongan",
				"Torres Strait Islander",
				"Trinidadian (Tobagonian)",
				"Tunisian",
				"Turkish",
				"Turkmen",
				"Tuvaluan",
				"Ugandan",
				"Uighur",
				"Ukrainian",
				"Uruguayan",
				"Uzbek",
				"Venezuelan",
				"Vietnamese",
				"Vlach",
				"Welsh",
				"Western European",
				"Yemeni",
				"Yoruba",
				"Zambian",
				"Zimbabwean",
				"Zulu"
			],
			languages: [
				"Acholi",
				"Afrikaans",
				"Albanian",
				"Alyawarr (Alyawarra)",
				"Amharic (Ethiopean)",
				"Anyuak/Anuak",
				"Arabic",
				"Arakanese/Rakhinz",
				"Armenian",
				"Arrernte (Aranda)",
				"Asante/Ashanti",
				"Assamese (Indian)",
				"Assyrian (Including Aramaic)",
				"Assyrian",
				"Australian Indigenous Lang",
				"Azari",
				"Azerbaijani",
				"Baluchi/Balochi",
				"Bambara",
				"Bari/Beri",
				"Basque",
				"Bassa",
				"Bemba",
				"Bengali (Indian)",
				"Bisaya",
				"Bislama",
				"Bodo (Indian)",
				"Bosnian",
				"Breton",
				"Bulgarian",
				"Burarra",
				"Byelorussian",
				"Cantonese",
				"Catalan",
				"Cebuano",
				"Chaldean",
				"Chi-Nyanja/Nyanja",
				"Chichewa/Chewa",
				"Chin Haka (Dialect of Chin)",
				"Chin (Indian)",
				"Chinese (All Dialects)",
				"Chizigula/Zigula",
				"Coptic",
				"Croatian",
				"Czech",
				"Dan/Gio",
				"Danish",
				"Dari",
				"Dinka",
				"Divehi",
				"Dogri (Indian)",
				"Dutch",
				"Dzongkha",
				"Eastern Asian Languages",
				"Eastern European Lang",
				"Esperanto",
				"Estonian",
				"Ewe",
				"Falam Chin (Dialect of Chin)",
				"Fanti/Fante",
				"Farsi (Persian)",
				"Fiji Hindi",
				"Fijian",
				"Filipino/Tagalog",
				"Finnish",
				"Flemish",
				"Foochow (Chinese)",
				"French",
				"Fukien (Chinese)",
				"Fulani",
				"Fullah",
				"Fulliru",
				"Fuqing",
				"Fur",
				"Fuzhou (Chinese)",
				"Gaelic (Ireland)",
				"Gaelic (Scotland)",
				"Galician",
				"Gan",
				"Georgian",
				"German",
				"Gilbertese",
				"Gio/Dan",
				"Greek",
				"Gro",
				"Gujarati (Indian)",
				"Hainanese (Chinese)",
				"Haitian",
				"Hakka (Chinese)",
				"Hakka (Timorese)",
				"Harari",
				"Hassani (Dialect of Arabic)",
				"Hassaniya (Dialect of Arabic)",
				"Hasseniyya (Dialect of Arabic)",
				"Hausa",
				"Hawaiian",
				"Hazaragi",
				"Hebrew",
				"Hindi (Indian)",
				"Hindustani/Hindi-Urdu",
				"Hmong",
				"Hokkien (Chinese)",
				"Hungarian",
				"Icelandic",
				"Igbo/Ibo",
				"Ikalanga/Kalanga",
				"Indian (All Dialects)",
				"Indonesian",
				"Irish",
				"Italian",
				"Japanese",
				"Javanese",
				"Juba/Arabic Pidgin",
				"Kachin",
				"Kakwa",
				"Kalentin",
				"Kannada (Indian)",
				"Karen",
				"Karenni/Kayah",
				"Kashmiri (Indian)",
				"Kazakh",
				"Khmer",
				"Khumi (Dialect of Chin)",
				"Ki-Kongo",
				"Ki-Kuyu",
				"Ki-Luba/Luba",
				"Kikuyu",
				"Kingoni",
				"Kinjanda",
				"Kinyarwanda",
				"Kirghiz",
				"Kirundi",
				"Kissi",
				"Kiswahili",
				"Konkani (Indian)",
				"Kono",
				"Korean",
				"Kpelle",
				"Krio",
				"Kriol",
				"Kuanua/Tolai",
				"Kuku",
				"Kunama",
				"Kurdish (Badini)",
				"Kurdish (Faili)",
				"Kurdish (Gorani)",
				"Kurdish (Irani/Kurdistani)",
				"Kurdish (Kurmanji)",
				"Kurdish (Sorani)",
				"Kuurinji (Gurindji)",
				"Kwa",
				"Lao",
				"Latin",
				"Latvian",
				"Liberian Pidgin",
				"Limba",
				"Lingala",
				"Lisu",
				"Lithuanian",
				"Loko",
				"Loma",
				"Lori",
				"Luganda",
				"Luo",
				"Luwa",
				"Macedonian",
				"Madi",
				"Maithili (Indian)",
				"Malagasy",
				"Malayalam (Indian)",
				"Malaysian/Malay/Cocos Malay",
				"Malinka",
				"Maltese",
				"Mandarin",
				"Mandingo",
				"Mano",
				"Maori",
				"Mara (Dialect of Chin)",
				"Marathi (Indian)",
				"Maru",
				"Mashi",
				"Matu (Dialect of Chin)",
				"Mauritian Creole",
				"Meitei (Indian)",
				"Mende",
				"Mina",
				"Mizo Chin (Dialect of Chin)",
				"Moldavian",
				"Mon",
				"Mongolian",
				"Moru",
				"Motu",
				"Mundari",
				"Myanmar (Burmese)",
				"Nauruan",
				"Ndebele/Jindebele",
				"Nepalese (Indian)",
				"Netherlandic",
				"Non Verbal",
				"Northern European Lang",
				"Norwegian",
				"Not Stated/Inadequately Desc",
				"Nubia",
				"Nuer",
				"Nyagwara",
				"Odia (Indian)",
				"Oriya/Odia",
				"Oromo",
				"Other African Languages",
				"Other Asian Languages",
				"Other European Languages",
				"Other Languages",
				"Other Oceanic Languages",
				"Other",
				"Ov-Ambo",
				"Papiamento",
				"Pashtu/Pashto",
				"Pedi/Northern Soto",
				"Pidgin/Neo-Melanesian",
				"Pintupi",
				"Pitjantjatjara",
				"Pojulu",
				"Polish",
				"Portuguese",
				"Pukapuka",
				"Pulaar",
				"Punjabi (Indian)",
				"Pwo Karen (Dialect of Karen)",
				"Quechua",
				"Rajasthani",
				"Rohingya (Myanmar)",
				"Rohinya (Cook Islands)",
				"Romanian",
				"Romansch",
				"Romany",
				"Russian",
				"Saho",
				"Samoan",
				"Sanskrit (Indian)",
				"Santali (Indian)",
				"Sardinian",
				"Serbian",
				"Setswana",
				"Sgaw Karen (Dialect of Karen)",
				"Shan",
				"Shanghainese",
				"Shilenge",
				"Shiluk",
				"Shona/Chishona",
				"Sichuan",
				"Sidamic",
				"Sindhi (Indian)",
				"Sinhalese",
				"Siym (Dialect of Chin)",
				"Slovak",
				"Slovene",
				"Somali",
				"Sotho",
				"Southeast Asian Languages",
				"Southern Asian Languages",
				"Southern European Lang",
				"Spanish",
				"Sudanese Arabic",
				"Sukuma",
				"Susu",
				"Sw Asian/N African Lang",
				"Swahili/Ki-Swahili",
				"Swazi",
				"Swedish",
				"Syriac",
				"Tajik",
				"Tamil (Indian)",
				"Tartar",
				"Tedim Chin (Dialect of Chin)",
				"Telugu (Indian)",
				"Temne",
				"Teo Chiew (Chinese)",
				"Tetum (Timorese)",
				"Thai",
				"Tibetan",
				"Tigre",
				"Tigrinya",
				"Tiv",
				"Tiwi",
				"Tokelauan",
				"Tongan",
				"Tshiluba",
				"Tsonga",
				"Turkish",
				"Turkmen",
				"Twi",
				"Uighur",
				"Ukrainian",
				"Urdu (Indian)",
				"Uzbek",
				"Vietnamese",
				"Walmajarri (Walmadjari)",
				"Warlpiri",
				"Watchi",
				"Welsh",
				"Wendish",
				"Wik-Mungkan",
				"Wolof",
				"Xhosa",
				"Yalunka",
				"Yiddish",
				"Yoruba",
				"Yugoslavian",
				"Zande",
				"Zomi (Dialect of Chin)",
				"Zonot (Dialect of Chin)",
				"Zulu"
			],
			religions: [
				"Aboriginal Evangelical Missions",
				"Agnosticism",
				"Albanian Orthodox",
				"Ancestor Veneration",
				"Ancient Church of the East",
				"Anglican",
				"Anglican Catholic Church",
				"Anglican Church of Australia",
				"Animism",
				"Antiochian Orthodox",
				"Apostolic Church (Australia)",
				"Apostolic Church of Queensland",
				"Armenian Apostolic",
				"Assemblies of God",
				"Assyrian Apostolic",
				"Assyrian Church of the East",
				"Atheism",
				"Australian Aboriginal Traditional Religions",
				"Baha'i",
				"Baptist",
				"Bethesda Churches",
				"Born Again Christian",
				"Brethren",
				"Buddhism",
				"Caodaism",
				"Catholic",
				"Chaldean Catholic",
				"Chinese Religions",
				"Christadelphians",
				"Christian",
				"Christian & Missionary Alliance",
				"Christian City Church",
				"Christian Life Churches International",
				"Christian Outreach Centres",
				"Christian Revival Crusade",
				"Christian Science",
				"Church of Christ (Non-denominational)",
				"Church of Jesus Christ of LDS",
				"Church of Scientology",
				"Church of the Nazarene",
				"Churches of Christ",
				"Churches of Christ (Confirmed)",
				"Community of Christ",
				"Confucianism",
				"Congregational",
				"Coptic Orthodox Church",
				"Druidism",
				"Druse",
				"Eastern Orthodox",
				"Eckankar",
				"Ethiopian Orthodox Church",
				"Ethnic Evangelical Churches",
				"Faith Churches",
				"Foursquare Gospel Church",
				"Free Reformed",
				"Full Gospel Church",
				"Gnostic Christians",
				"Greek Orthodox",
				"Hinduism",
				"Humanism",
				"Independent Evang. Churches",
				"International Church of Christ",
				"Islam",
				"Jainism",
				"Japanese Religions",
				"Jehovah's Witnesses",
				"Judaism",
				"Latter-day Saints",
				"Liberal Catholic Church",
				"Lutheran",
				"Macedonian Orthodox",
				"Maronite Catholic",
				"Melkite Catholic",
				"Nature Religions",
				"New Apostolic Church",
				"New Churches (Swedenborgian)",
				"No religion",
				"Oriental Orthodox",
				"Other Christian",
				"Other Protestant",
				"Paganism",
				"Pantheism",
				"Pentecostal",
				"Presbyterian",
				"Presbyterian and Reformed",
				"Rastafarianism",
				"Ratana (Maori)",
				"Rationalism",
				"Reformed",
				"Religious Science",
				"Religious Society of Friends",
				"Revival Centres",
				"Rhema Family Church",
				"Romanian Orthodox",
				"Russian Orthodox",
				"Salvation Army",
				"Satanism",
				"Serbian Orthodox",
				"Seventh-day Adventist",
				"Shinto",
				"Sikhism",
				"Spiritualism",
				"Sukyo Mahikari",
				"Syrian Orthodox Church",
				"Taoism",
				"Temple Society",
				"Tenrikyo",
				"Theosophy",
				"Ukrainian Catholic",
				"Ukrainian Orthodox",
				"Unitarian",
				"United Pentecostal",
				"Uniting Church",
				"Wesleyan Methodist Church",
				"Western Catholic",
				"Wiccan/Witchcraft",
				"Worldwide Church of God",
				"Zoroastrianism"
			]
		},
		userRoleContent: {
			super: {
				label: "Super",
				privileges: ["everything"]
			},
			owner: {
				label:
					"the primary contact for **ORGNAME** as the **Owner**, with access to",
				privileges: [
					"create, edit and delete listings",
					"view reports on listing performance",
					"set and manage billing info",
					"invite other users"
				]
			},
			admin: {
				label: "**Admin** for **ORGNAME** with access to",
				privileges: [
					"create, edit and delete listings",
					"view reports on listing performance",
					"set and manage billing info",
					"invite other users"
				]
			},
			manager: {
				label: "a **Listing Manager** for **ORGNAME** with access to",
				privileges: [
					"create, edit and delete listings",
					"view reports on listing performance"
				]
			},
			editor: {
				label: "a **Listing Editor** for **ORGNAME** with access to",
				privileges: ["edit listings that they have been assigned access to"]
			},
			"vacancy-editor": {
				label: "a **Vacancy Editor** for **ORGNAME** with access to",
				privileges: ["edit room vacancies for aged care facility listings"]
			}
		}
	},
	getters: {
		activities: state => state.activities,
		amenities: state => state.amenities,
		applicationUserRoles: (state: any) => {
			const listingRoles = state.listingUserRoles;
			const hospitalRoles = state.hospitalUserRoles;
			const dailyDataRoles = state.dailyDataUserRoles;
			const dailyCareRoles = state.dailyCareUserRoles;
			return [
				...hospitalRoles,
				...dailyDataRoles,
				...listingRoles,
				...dailyCareRoles
			];
		},
		archiveReasons: state => state.archiveReasons,
		australianStates: state => state.states,
		careneeds: state => state.careneeds,
		caretypes: state => state.caretypes,
		complexneeds: state => state.complexneeds,
		dailyDataUserRoles: state => state.dailyDataUserRoles,
		dailyCareUserRoles: state => state.dailyCareUserRoles,
		facilitySpecialisations: state => state.caretypes.mentalhealth,
		financials: (state: any) => state.financialCircumstances,
		gender: (state: any) => state.gender,
		healthServiceTypes: (state: any) => state.healthServiceTypes,
		homecare: (state: any) => state.homecare,
		hospitalTypes: (state: any) => state.hospitalTypes,
		hospitalUserRoles: (state: any) => state.hospitalUserRoles,
		listingCategories: (state: any) => state.listingCategories,
		listingPlans: (state: any) => state.listingPlans,
		listingUserRoles: (state: any) => state.listingUserRoles,
		notificationTypes: (state: any) => state.notificationTypes,
		organisationTypes: (state: any) => state.organisationTypes,
		paperworkStatus: (state: any) => state.paperworkStatus,
		roomoptions: (state: any) => state.roomoptions,
		searchActivitiesTypes: (state: any) => state.searchActivitiesTypes,
		searchReasons: (state: any) => state.searchReasons,
		searchTypes: (state: any) => state.searchTypes,
		specialisations: (state: any) => state.specialisations,
		subscription: (state: any) => state.subscription,
		userRoleContent: (state: any) => state.userRoleContent,
		userRoles: (state: any) => state.userRoles
	}
};
// eslint-disable-line
